import { AmplitudeInterface } from './types';

const stub = (method: string) => {
  return (...args: any[]) => {
    console.log(`Calling Amplitude.${method} with args:`, ...args);
  };
};

export const initAmplitudeStub = (): AmplitudeInterface => {
  stub('init');

  return {
    track: stub('track'),
    flushOnExit: stub('flushOnExit'),
    identify: stub('identify'),
    reset: (...args: any[]) => {
      stub('reset')(...args);

      return Promise.resolve();
    },
  };
};
